const SupportingDocumentType = {
  FETCH_SUPPORTING_DOCS: 'FETCH_SUPPORTING_DOCS',
  DELETE_SUPPORTING_DOCS: 'DELETE_SUPPORTING_DOCS',
  UNMOUNT_SUPPORTING_DOCS: 'UNMOUNT_SUPPORTING_DOCS',
  FETCH_MERGED_DOCS: 'FETCH_MERGED_DOCS',
  DELETE_MERGED_DOCS: 'DELETE_MERGED_DOCS',
};

export default SupportingDocumentType;
